import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { CreditsContext } from '@stores/CreditsContext';
import NewUser from '@components/user/NewUser';
import PriorUserNoCredits from '@components/user/PriorUserNoCredits';

const SubmissionCreateNoCredits = () => {
  const { creditsInfo } = useContext(CreditsContext);
  return(
    <Center>
      <Content>
        { creditsInfo.creditsUsed > 0 ? <PriorUserNoCredits /> : <NewUser/> }
      </Content>
    </Center>
  )
}

export default SubmissionCreateNoCredits;

const Center = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  width: 800px;
`;
